import {connect} from 'react-redux';
import StepHandler from './StepHandler';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {showGlobalErrorMessage}
)(StepHandler);
